import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useForm } from 'react-hook-form';
import { CheckInCheckOut } from './CheckInCheckOut';
import { closeFingerTemplate } from '../../../components/biometric/closeFingerPrint';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    height: 'auto',
    bgcolor: 'background.paper',

    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

export default function BioModal({ fingerControl, open, setOpen, refetch, state, setState }: { fingerControl: any, refetch: any, open: boolean, setOpen: (value: boolean) => void, state: any, setState: any }) {
    const initialValues = { fingerTemplate: "" }

    const { handleSubmit } = useForm({
        defaultValues: initialValues
    });

    const handleClose = () => {
        if (state?.opId) {
            closeFingerTemplate(state, setState)
        }
        setOpen(false)
    };
    const onCapture = (data: any) => {
        setOpen(false)
    }

    return (
        <div>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Stack sx={style} gap={2}>
                    <Typography variant="h5" component="h5" mb={1} fontWeight={500} textAlign='center'>
                        For exiting visitors
                    </Typography>
                    <CheckInCheckOut fingerControl={fingerControl} handleSubmit={handleSubmit} onCapture={onCapture} inputType={'checkOut'} refetch={refetch} state={state} setState={setState} />
                    <Button onClick={() => handleClose()} sx={{ color: ' #EB5757' }}>
                        <Typography >CANCEL</Typography>
                    </Button>
                </Stack>
            </Modal>
        </div>
    );
}